import { render } from "./CharityProject.vue?vue&type=template&id=1af6ceac&scoped=true"
import script from "./CharityProject.vue?vue&type=script&lang=js"
export * from "./CharityProject.vue?vue&type=script&lang=js"

import "./CharityProject.vue?vue&type=style&index=0&id=1af6ceac&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0b0c69fa16feb22e92fe2dae88baf76f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af6ceac"]])

export default __exports__